"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    flatTreeClassNames: function() {
        return flatTreeClassNames;
    },
    useFlatTreeStyles_unstable: function() {
        return useFlatTreeStyles_unstable;
    }
});
const _react = require("@griffel/react");
const flatTreeClassNames = {
    root: 'fui-FlatTree'
};
const useBaseStyles = /*#__PURE__*/ (0, _react.__resetStyles)("rnv2ez3", null, [
    ".rnv2ez3{display:flex;flex-direction:column;row-gap:var(--spacingVerticalXXS);}"
]);
const useFlatTreeStyles_unstable = (state)=>{
    'use no memo';
    const baseStyles = useBaseStyles();
    state.root.className = (0, _react.mergeClasses)(flatTreeClassNames.root, baseStyles, state.root.className);
    return state;
}; //# sourceMappingURL=useFlatTreeStyles.styles.js.map
